var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhonePurple = function SvgPhonePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.81 12.852-4.391-1.881a1.496 1.496 0 0 0-1.423.13l-2.348 1.565a7.176 7.176 0 0 1-3.3-3.286l1.56-2.383a1.497 1.497 0 0 0 .123-1.412L6.147 1.19a1.503 1.503 0 0 0-1.56-.898A5.257 5.257 0 0 0 0 5.5C0 12.944 6.056 19 13.5 19a5.257 5.257 0 0 0 5.208-4.586 1.503 1.503 0 0 0-.898-1.562Z",
    fill: "#7160C5"
  })));
};

export default SvgPhonePurple;